// Generated by CoffeeScript 2.7.0
var RedPacketQuotasMixin, USER_GROUP;

USER_GROUP = [
  {
    title: '用户详情',
    option: {
      name: '姓名',
      identifier: '识别码',
      phone: '手机号'
    }
  },
  {
    title: '额度详情',
    option: {
      total_amount: '总额度',
      available_amount: '剩余额度'
    }
  }
];

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

export default RedPacketQuotasMixin = {
  components: {
    'modal': Modal,
    'user-item': UserItem
  },
  props: {
    initialRedPacketQuotas: {
      type: Object
    }
  },
  data: function() {
    return {
      groups: USER_GROUP,
      redPacketQuotas: this._parseRedPacketQuotas()
    };
  },
  methods: {
    _parseRedPacketQuotas: function() {
      var redPacketQuotas;
      redPacketQuotas = this.initialRedPacketQuotas;
      redPacketQuotas.name = this.initialRedPacketQuotas.user.name;
      redPacketQuotas.identifier = this.initialRedPacketQuotas.user.identifier;
      redPacketQuotas.phone = this.initialRedPacketQuotas.user.phone;
      return redPacketQuotas;
    }
  }
};
